import React, { useEffect, useState } from "react";
import {useParams, useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import { Bgloader } from "../../Common/Background/Bgloader";
import { Footer } from "../../Common/Footer/Footer";
import "./verifyMail.css";
import {base_url} from "../BackendAPIUrl";
import ClipLoader from "react-spinners/ClipLoader";

const VerifyMail = ({ lang }) => {
  const [errorMsg, setErrorMsg] = useState("asd");
  const [loading, setLoading] = useState(false);
  const [search] = useSearchParams();
  const navigate = useNavigate();

    useEffect(() => {
        if (!(search && search.has('code'))) {
            navigate('/login');
        }
    }, [search]);

  const resend = async () => {
      setLoading(true);
      try {
          const formData = new FormData();
          formData.append("code", search.get("code"));
          const response = await axios.post(
              `${base_url}/api/resend-email-verification/`,
              formData
          );
          if (response.status === 200) {
              navigate("/login");
          }
      } catch (response) {
          setLoading(false);
      } finally {
          setLoading(false);
      }
  }

  return (
    <div className={`verify-wrapper relative`}>
        <div className="error-popup !bg-yellow-50">
            <p>{lang === 'ar' ? 'يرجى التحقق من عنوان بريدك الإلكتروني': 'Please verify you email address'}</p>
            <button disabled={loading} className="signin uppercase w-auto h-auto p-2" onClick={() => resend()}>
                <div className={'flex items-center justify-center gap-2'}>
                    {loading && <ClipLoader size={20} color={"#FFFFFF"} />}
                    Resend Verification
                </div>
            </button>
        </div>

      <div className={`${errorMsg && "absolute bottom-0 w-full"}`}>
        <Footer isLang={lang} />
      </div>
    </div>
  );
};

export default VerifyMail;
